import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "vuetify/dist/vuetify.min.css";
import "@redeam/vue-common-components/dist/vue-common-components.css";
import { RdmVuetifyConfig } from "@/plugins/RdmVuetifyConfig";

Vue.use(Vuetify);

export default new Vuetify(RdmVuetifyConfig);
